import { createContext, useContext } from "react";

import { GenericCalendarEntry } from "../components/Calendar/Calendar";
import { TypedEventEmitter } from "../eventEmmiters/typedEventEmitter";
import { UseCalendarResult } from "../hooks/useCalendar";

export type CalendarContextEventsMap = {
  // list of supported events
  example: undefined;
};

export class CalendarContextValue<
  TEntry extends GenericCalendarEntry,
> extends TypedEventEmitter<CalendarContextEventsMap> {
  private _calendar: UseCalendarResult<TEntry>;

  constructor(params: { calendar: UseCalendarResult<TEntry> }) {
    super();
    this._calendar = params.calendar;
  }

  public openEntryViewPopover(params: { entry: TEntry; anchorEl: HTMLElement }): void {
    this._calendar.openEntryViewPopover(params);
  }

  public closeEntryViewPopover(params: { entry: TEntry | null }): void {
    this._calendar.closeEntryViewPopover(params);
  }
}

export const CalendarContext = createContext<CalendarContextValue<GenericCalendarEntry> | null>(
  null,
);

export function useCalendarContext<
  TEntry extends GenericCalendarEntry,
>(): CalendarContextValue<TEntry> {
  const calendarContext = useContext(CalendarContext);

  if (!calendarContext) {
    throw new Error(
      "useCalendarContextRequired() has to be used within <CalendarContext.Provider>",
    );
  }

  return calendarContext as unknown as CalendarContextValue<TEntry>;
}

export function useCalendarContextOptional<
  TEntry extends GenericCalendarEntry,
>(): CalendarContextValue<TEntry> | null {
  const calendarContext = useContext(CalendarContext);
  return calendarContext as unknown as CalendarContextValue<TEntry>;
}
